export const questions: Array<[string, string]> = [
  [
    '¿Cómo recibo el Megapack después de comprar?',
    'Recibirás el acceso al material de forma inmediata por correo electrónico para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.',
  ],
  [
    '¿Para qué nivel educativo está pensado?',
    'El material está diseñado para instituciones técnicas, escuelas secundarias, terciarios y formación profesional. Los 9 tomos te permiten adaptar el nivel según necesites.',
  ],
  [
    '¿Sirve para cualquier país hispanohablante?',
    'Sí. El material está actualizado a 2026 y es válido para toda Latinoamérica. Incluye contextos mineros específicos de la región con énfasis en desarrollos característicos de Latinoamérica, con orientaciones para adaptar contenidos según tu país.',
  ],
  [
    '¿El material es editable?',
    'Sí. Recibes todos los PDF en formato editable para que puedas personalizarlos con tu nombre, institución o contexto local.',
  ],
  [
    '¿En qué moneda voy a pagar?',
    'Pagas en USD (dólares estadounidenses). Tu plataforma de pago te mostrará la conversión en tu moneda local automáticamente.',
  ],
  [
    '¿Qué hace diferente este megapack de otros materiales?',
    'Este megapack no es una colección de actividades sueltas. Es un sistema completo: 9 tomos coherentes, 5 bonos estratégicos, ejercicios de análisis estructurado, evaluaciones listas, 100 casos prácticos y 50 proyectos de pensamiento crítico. Todo pensado para que no improvises nunca más.',
  ],
  [
    '¿Qué pasa si no me gusta?',
    'Tienes 7 días para revisar todo. Si en ese tiempo sientes que no es lo que esperabas o que no te aporta valor, solicitas la devolución y te reembolsamos el 100% sin preguntas.',
  ],
];
